import * as Models from "../../Models";
import {StatisticsContentProvider } from "../../../DataFacade";
import { IEventsExtendedData } from "../../../Interfaces";

export class ExtendedDataParser {

    public static parse(newExtendedData: IEventsExtendedData,
        statisticsProvider: StatisticsContentProvider): Models.ExtendedData {

        let hasStatistics = this.hasStatistics(statisticsProvider, newExtendedData);
        let hasLiveStream = newExtendedData.HasLiveStream;

        let statisticsInfo = this.getStatisticsInfo(hasStatistics, newExtendedData, statisticsProvider);

        return new Models.ExtendedData({
            eventId: newExtendedData.EventId,
            linkURL: newExtendedData.LinkURL,
            hasLiveStream,
            hasStatistics,
            statisticsInfo
        })
    }

    public static getStatisticsInfo(hasStatistics: boolean, extendedData: IEventsExtendedData | undefined, statisticsProvider: StatisticsContentProvider): any | undefined {
        if (!extendedData || !hasStatistics) { return undefined }
        return {
            betRadarData: {
                clientId: statisticsProvider.betRadarClientId,
                eventId: parseInt(extendedData.BetRadarStatisticsEventId) ? parseInt(extendedData.BetRadarStatisticsEventId) : 0
            },
            enetPulseData: {
                homeTeamId: extendedData.HomeEnetplusID,
                awayTeamId: extendedData.AwayEnetplusID,
                branchId: Number(extendedData.ENetPulsBranchID)
            }
        }
    }

    private static hasStatistics(statisticsProvider, extendedData): boolean {
        return (
            (statisticsProvider.useStatistics &&
                statisticsProvider.factory.isStatsAvailableMainEvent(extendedData, {EnetPulseID: extendedData.ENetPulsBranchID})
            )
        )

    }

}
